import { GoogleGenAI } from "@google/genai";
import { Product } from "../types";

// Initialize the Gemini client with the API key from the environment
// We use a safe check for process.env to prevent crashes in non-Node environments if the build shim fails
const getApiKey = () => {
  try {
    return process.env.API_KEY;
  } catch (error) {
    console.warn("API Key not found in environment");
    return "";
  }
};

const ai = new GoogleGenAI({ apiKey: getApiKey() });

export const getBaristaRecommendation = async (
  userQuery: string,
  menuItems: Product[]
): Promise<string> => {
  try {
    const menuContext = menuItems.map(item => 
      `- ${item.name} (₱${item.price}): ${item.description} [Category: ${item.category}]`
    ).join('\n');

    const systemInstruction = `
      You are "Moon Bot", the AI Barista at "8 Moon Cafe".
      Your tone is celestial, warm, and mysterious but helpful.
      You should recommend items from the menu based on the user's mood or request.
      
      Here is our current menu:
      ${menuContext}
      
      Rules:
      1. Only recommend items on the menu.
      2. Keep responses concise (under 50 words).
      3. Use coffee or space/moon related puns occasionally.
      4. If the user asks something unrelated, gently steer them back to coffee or the moon.
      5. Prices are in Philippine Peso (₱).
    `;

    const response = await ai.models.generateContent({
      model: "gemini-2.5-flash",
      contents: userQuery,
      config: {
        systemInstruction: systemInstruction,
        temperature: 0.7,
      },
    });

    return response.text || "The stars are silent today. Try our Espresso.";
  } catch (error) {
    console.error("Gemini Error:", error);
    return "I'm sensing some interference in the nebulas. I can't reach my cloud mind right now, but I'd recommend our signature Galactic Espresso! ☕";
  }
};